import React from 'react';

import * as formatters from '../../../utils/formatters';
import BooleanIcon from '../../elements/booleanIcon';
import TableDataValue from '../../elements/tableDataValue';

import { getPromoCodeBonusDisplay } from './PromoCodeCampaigns';

import Card from 'crm/elements/common/Card';
import Row, { TableDetailsBody } from 'crm/elements/common/TableDetailsRow';

function PromoCodeDetails({ promoCode }) {
    const { formatDate, formatCurrency } = formatters;

    return (
        <Card title="Promo Code details">
            <TableDetailsBody>
                <Row label="Prefix">{promoCode.prefix}</Row>
                <Row label="Use place">{promoCode.use_place}</Row>
                <Row label="Bonus">{getPromoCodeBonusDisplay(promoCode.bonus)}</Row>
                <Row label="Affiliate" showIf={!!promoCode.affiliate_name}>
                    {promoCode.affiliate_name} [{promoCode.affiliate_token}]
                </Row>
                <Row label="Lottery">{promoCode.lottery_name}</Row>
                <Row label="Discount amount">
                    {promoCode.bonus === 'percentage_discount' ? (
                        `${promoCode.discount_amount ?? 0}%`
                    ) : (
                        <TableDataValue value={formatCurrency(promoCode.discount_amount)} />
                    )}
                </Row>
                <Row label="Start date">{formatDate(promoCode.start_date, true)}</Row>
                <Row label="Max uses">{promoCode.max_uses}</Row>
                <Row label="End date">{formatDate(promoCode.end_date, true)}</Row>
                <Row label="Active">
                    <BooleanIcon value={promoCode.is_enabled} />
                </Row>
            </TableDetailsBody>
        </Card>
    );
}

export default PromoCodeDetails;
